<template>
  <div class="user-agreement">
    <loader v-if="!customHtml"></loader>
    <div class="remoteContent" v-html="customHtml"></div>
    <!--    TODO Remove after testing on production-->
    <div v-if="reservedInfo">
      <div class="row top">
      <div class="col header-text">
        <h1>User Agreement</h1>
      </div>
    </div>
      <div class="container">
      <div class="row">
        <div class="col-lg-12 ua">
          <div class="effective">Effective as of 25.11.2020</div>
          <ol class="main">
            <li class="big-title">General
              <ol>
                <li>The terms and conditions of this user agreement (the <strong>“User Agreement”</strong>) apply to any person who has completed the registration process via www.getincome.com (the
                  “<strong>Website</strong>”).
                </li>
                <li>This User Agreement constitutes a legally binding agreement between an investor (the “<strong>Investor</strong>”) and Income Company OÜ (Estonian registry code 16014116, “<strong>Income</strong>”),
                  mainly in relation
                  with the
                  use of the peer-to-peer marketplace accessible via the Website and operated by Income (the “<strong>Marketplace</strong>”).
                </li>
                <li>For the purposes of this User Agreement, any reference to “we”, “us”, “our”, “Income” and/or any similar term shall be construed as reference to Income, any references to “you” and
                  “your”
                  shall be construed as a reference to you as an Investor.
                </li>
                <li>In addition to this User Agreement, please also read the Privacy Policy of the Marketplace which provides you important information about how we process your personal data which
                  you have
                  provided to us.
                </li>
                <li><strong>By registering as an Investor, you enter into this User Agreement and acknowledge that you are solely responsible for complying with all laws, regulations and requirements
                  of the
                  jurisdiction
                  in which you live that may be applicable to your use of the Marketplace, including but not limited to those related to taxation, foreign currency transactions, any reporting,
                  registration,
                  or
                  licencing requirements which may apply to you.</strong>
                </li>
              </ol>
            </li> <!--1.-->
            <li class="big-title">Registration
              <ol>
                <li><strong>Requirements for natural persons.</strong> To open an investor account on the Marketplace you have to be a natural person of at least 18 years old whose active legal
                  capacity is not restricted
                  and who
                  is a resident of a member state of the European Economic Area or Switzerland (to be proven by personal identification documents and other documents required at the discretion of
                  Income).
                </li> <!--2.1.-->
                <li><strong>Requirements for legal persons.</strong> To open an investor account on the Marketplace for a legal person, the legal person must be incorporated in a member state of the
                  European Economic Area
                  or
                  Switzerland and have unrestricted active legal capacity (to be proven by the registry extract of the legal person, articles of association and other documents required at the
                  discretion of
                  Income). The representative of a legal person must provide us with their personal identification document, proof of their right of representation of the legal person and any other
                  documents
                  required at the discretion of Income.
                </li> <!--2.2.-->
              </ol>
            </li> <!--2.-->
            <li class="big-title">
              Collecting data
              <ol>
                <li><strong>Information disclosure obligation.</strong> During the registration process of an Investor as well as at any time after that, we may require you to provide data and
                  documents to us so that we
                  could
                  verify your identity, understand your background and business activities and carry out other procedures to comply with our know-your-customer principles. The exact data which must be
                  provided to
                  us prior to registration shall be determined in the registration form. In case we need any additional data, or in case we need you to update the data you have provided, a
                  notification
                  shall be
                  given via the Marketplace or via e-mail. We will let you know whether submitting the data we have asked for is obligatory or voluntary or which communication channels you should use
                  for
                  providing
                  us the requested data.
                </li>
                <li><strong>Personal data processing.</strong> If you have shared personal data with us (either your own personal data or, if you are a legal person, personal data of your
                  representatives, managers,
                  shareholders
                  or beneficial owners), then further information about processing of the personal data has been provided in the Privacy Policy accessible on our Website.
                </li>
                <li><strong>Consequences of not providing data.</strong> Failure to submit the data requested from you may lead to us limiting your use of the Marketplace, which may, among other, mean
                  preventing you from
                  entering into any transactions in respect to the claims which can be purchased via the Marketplace (the “<strong>Claims</strong>”) or termination of this User Agreement between us,
                  if we deem it necessary.
                </li>
                <li><strong>Password.</strong> To enter the Marketplace, you may be asked to generate a password. The password chosen by you is personal to you and is only used to identify you when
                  you log onto the
                  Marketplace
                  and enter into transactions there. We may allow you to access the Marketplace by identifying yourself via your social media accounts or other means made available on the Website.
                </li>
                <li><strong>Confidentiality of account information.</strong> When creating an investor account, you undertake to keep your account details (and especially your password) confidential.
                  It is presumed that the
                  person logged onto the Marketplace with your account details is you and/or has authorisation, arising from either law or contract, to enter into any transactions in your name. Any
                  transaction
                  entered into on the Marketplace using your account details shall be binding on you.
                </li>
              </ol>
            </li> <!--3.-->
            <li class="big-title">Investor’s Obligations
              <ol>
                <li>By accepting the terms and conditions of this User Agreement, you
                  <ol>
                    <li>undertake to follow the terms and conditions of this User Agreement and the laws in your country of residency and/or country from which you access the Website when using our
                      services;
                    </li>
                    <li>undertake to immediately inform us about any changes to the information you have provided to us in the course of the registration process or afterwards and keep the information
                      which
                      you
                      can amend by yourself on your investor account up to date;
                    </li>
                    <li>undertake to immediately inform us about any unusual, suspicious, unclear or abnormal changes on your investor account;</li>
                    <li>undertake to avoid gaining unauthorised access to the Website or the Marketplace, including but not limited to, transmit or upload any document to the Website that contains
                      viruses,
                      Trojan
                      horses, worms etc;
                    </li>
                    <li>undertake to avoid transactions involving items that may help facilitate or enable illegal activities;</li>
                    <li>undertake to avoid intellectual property infringement;</li>
                    <li>undertake not to assign or transfer any of your rights or obligations under this User Agreement or any assignment agreements concluded via the Marketplace without our prior
                      written
                      approval, unless otherwise stipulated herein or in the relevant assignment agreement;
                    </li>
                    <li>acknowledge that you are responsible for determining whether the services provided via the Marketplace are appropriate for you, considering your personal goals, financial
                      status, and
                      risk
                      willingness;
                    </li>
                    <li>acknowledge that you are only allowed to open the investor account for your own use and not for giving it to the use of any third parties;</li>
                    <li>warrant that you will not use your investor account for or in relation with any illegal activity, in violation of any laws or regulations.
                    </li>
                  </ol>
                </li>
                <li>Should we detect that you are in breach of any of these obligations, we reserve the right to at our sole discretion either limit your use of the Marketplace, temporarily restrict
                  your
                  access
                  to the Marketplace and/or your investor account, or terminate this User Agreement.
                </li>
              </ol>
            </li> <!--4.-->
            <li class="big-title">Investor account
              <ol>
                <li><strong>Access to data.</strong> After successfully completing the registration process via the Website, an investor account will be created for you on the Marketplace. On your
                  investor account, you will
                  be
                  able to keep track of your investments made via the Marketplace (overview of performance of Claims, documentation related to the Claims, transaction data). We will also show you an
                  overview of the
                  data you have provided to us, data related to your activities on the Marketplace (transactions between you and Income) and the balance of your funds held by Income.
                </li>
                <li><strong>Changing data.</strong> On your investor account, you will be able to update some of the data you have provided to us. Should there be any faults in the data which you
                  cannot update or amend
                  yourself,
                  please contact us using the contact details provided in our Privacy Policy.
                </li>
                <li><strong>Access to Claims.</strong> You can use your investor account to access the Marketplace, view the details of the Claims listed on the Marketplace, and purchase Claims. The
                  exact data set which
                  will be
                  published on the Marketplace for each Claim may change from time to time but in any case, unless otherwise required by applicable law, we will not give you any personal data of the
                  borrowers who
                  are the actual debtors under the Claims which are listed on the Marketplace.
                </li>
              </ol>
            </li> <!--5.-->
            <li class="big-title">Funds transferred to investor account
              <ol>
                <li><strong>Adding funds to your investor account.</strong> You can only purchase Claims if you have a positive balance on your investor account and sufficient amount of funds for
                  making the relevant
                  purchase.
                  You are required to make all payments from a payment account opened in your name with a payment services provider duly licensed to provide services in the respective member state of
                  the
                  European
                  Economic Area or Switzerland. You may be asked to make your payments to Income in a certain currency acceptable to Income. We may refuse to accept funds which have been transferred
                  to your
                  investor account from a payment account of a third person or which do not otherwise comply with this clause.
                </li>
                <li><strong>Limitations to the use of funds.</strong> Any funds transferred to Income by you can only be used for making investments via the Marketplace and not for any other purpose.
                  Also, Income shall not
                  use
                  any such funds for its own benefit. Income keeps the funds transferred by you as a mandatory on your behalf in its own name on a designated payment account. Income keeps the relevant
                  funds
                  separately from its own funds.
                </li>
                <li><strong>Limitations to the positive balance of funds.</strong> Income can, at its own discretion, impose restrictions or requirements to the allowed minimum or maximum amounts of
                  funds held on the
                  investor
                  account. Income may return any positive balance on the investor account back to the payment account opened with a payment service provider in your name from which you made the last
                  payment
                  to
                  Income.
                </li>
                <li><strong>No interest.</strong> Income shall not calculate any interest and no interest is payable to you on the funds you have transferred to Income.
                </li>
                <li><strong>Access to transaction data.</strong> The balance of the funds you have transferred to Income and data on all transactions you have made via the Marketplace can be found on
                  the investor account.
                </li>
                <li><strong>Third party services.</strong> For regulatory purposes, we have the right to use third party service providers for administrating your funds and those of other investors.
                  For that purpose and for
                  you
                  to be able to keep using our services, we may ask you to sign up with any such third-party payment service provider who shall be holding the funds you can use for entering into
                  transactions on the
                  Marketplace.
                </li>
              </ol>
            </li> <!--6.-->
            <li class="big-title">Purchasing of Claims
              <ol>
                <li><strong>Preconditions.</strong> Before purchasing a Claim, you will be able to inspect the assignment agreement under which the Claim is transferred from the loan originator or
                  another Marketplace user
                  to
                  you. You can proceed only if you have confirmed that the terms of the assignment agreement are acceptable to you and if you have a positive balance on your investor account at least
                  in the
                  amount
                  to pay the price of the Claim.
                </li>
                <li><strong>Selecting Claims on the Marketplace.</strong> On the Marketplace, you will be shown all Claims which have been listed by loan originators or other Marketplace users and
                  have not yet been fully
                  purchased. Each Claim shall be listed together with information on the underlying loan and details of the Claim. Before you opt for purchasing a Claim, make sure you have inspected
                  all
                  data which
                  has been provided to you about the Claim as well as the terms and conditions of the assignment agreement.
                </li>
                <li><strong>Making purchasing decision.</strong> You will be able to purchase any Claim listed on the Marketplace either fully or partially. To purchase a part of a Claim, you will be
                  able to determine the
                  purchase price of a certain Claim which will allow you to purchase the proportion of the Claim corresponding to the purchase price.
                </li>
                <li><strong>Assignment Agreement.</strong> All Claims listed on the Marketplace can be purchased under the assignment agreement which is available to Investor on the Marketplace. From
                  time to time, some loan
                  originators may ask us for certain exemptions in which case any such information shall be provided to you under the information about the Claim. What is more, from time to time we
                  ourselves may
                  decide to make changes in the general terms and conditions of the assignment agreement in which case we will send you a notification beforehand and give you time to review the
                  changes.
                </li>
                <li><strong>Payment of purchase price.</strong> The purchase price will be deducted from the funds held by Income (or a third party appointed by Income) on your behalf at the same time
                  or immediately
                  following
                  your confirmation with which you accept the terms and conditions of the assignment agreement for the Claim. Once you have entered into an assignment agreement via the Marketplace,
                  the
                  positive
                  balance of your funds reflected on your investor account is reserved in the necessary extent until the payment arising from such transaction is made, and no other transaction or
                  withdrawal
                  can be
                  made by you on the account of these funds.
                </li>
                <li><strong>Completion of a transaction.</strong> An assignment agreement enters into force immediately after the preconditions for entering into the transaction (specified above) have
                  been fulfilled and the
                  price of the Claim has been deducted from your funds. After that, the title of the Claim will be transferred to you and the Claim will automatically appear on your investor account
                  under
                  the
                  active investments.
                </li>
                <li><strong>Withdrawal from the transaction.</strong> You cannot withdraw from the transaction unless otherwise specified in the relevant assignment agreement.
                </li>
                <li><strong>Transaction data.</strong> Data related to the performance of the Claim shall be provided to you on your investor account. This includes the assignment agreement related to
                  the transaction, the
                  information which was published by the loan originator on the Marketplace and the data related to the actual transaction (i.e. time and date of the transaction and payment schedule
                  applicable to
                  the Claim)
                </li>
              </ol>
            </li> <!--7.-->
            <li class="big-title">Automated purchasing of claims
              <ol>
                <li><strong>Authorising “autoinvest”.</strong> By authorising the autoinvest functionality, you are deemed to have approved and entered into assignment agreements in respect to the
                  Claims which meet the
                  criteria
                  you have determined. Prior to authorising the autoinvest functionality you shall be able to review the standard terms of assignment agreements which shall be part of the assignment
                  agreements to
                  be concluded automatically in your name via the Marketplace. By entering into this User Agreement and authorising the autoinvest functionality you also authorise us to allocate your
                  funds
                  to pay
                  the purchase price of each Claim (in accordance with clause 7.) in the aggregate amount you have determined for acquiring the Claims using autoinvest.
                </li>
                <li><strong>Determining the criteria for autoinvest.</strong> For the autoinvest to work, you must determine the criteria for the Claims which you would like to acquire. The criteria
                  may change from time to
                  time
                  but shall include at least the opportunity for you to pick the eligible loan originators and the minimum and maximum of loan amount from which the Claim derives, Claim size, interest
                  rate,
                  and
                  term of the Claim. You can also determine the maximum sum which can be allocated to a Claim, the aggregate value of transactions autoinvest is permitted to make on your behalf and
                  the
                  maximum
                  amount of funds which can be allocated by autoinvest. You may at any time change the criteria you have set. This will not affect any transactions which had been entered into before
                  such a
                  change.
                </li>
                <li><strong>Entering into a transaction.</strong> Autoinvest goes through all Claims on the Marketplace to find the ones which match the criteria you have predetermined. Once any such
                  Claim is detected, the
                  process of entering into the assignment agreement will be automatic and you will be notified of the assignment afterwards via the Marketplace or via e-mail.
                </li>
                <li><strong>Priority.</strong> In case several Marketplace users have authorised autoinvests with the same criteria, the Claims shall be allocated to the Marketplace users according to
                  the algorithm active
                  at the
                  time and subject to changes by Income from time to time. For the avoidance of doubt, authorising autoinvest functionality does not guarantee that you will be able to acquire any
                  Claims via
                  the
                  autoinvest functionality or how quickly you are able to acquire any Claims.
                </li>
                <li><strong>Restrictions.</strong> The autoinvest functionality can only be used to acquire Claims from the loan originators, not from other users of the Marketplace.
                </li>
                <li><strong>Revocation of autoinvest.</strong> You can always revoke the authorisation of autoinvest in which case no additional transactions will be made on your behalf by autoinvest.
                  This will not affect
                  any
                  transactions which had been entered into before the authorisation was revoked.
                </li>
                <li><strong>Limitation of our liability.</strong> If autoinvest acquires such Claims on your behalf which match the criteria you have determined, we are not responsible for the outcome
                  of the use of
                  autoinvest.
                  For example, we also cannot be held liable if autoinvest does not find suitable Claims for you or if any eligible Claims are not allocated to you.
                </li>
                <li><strong>Availability of autoinvest.</strong> We have full discretion to decide whether or not we make the autoinvest functionality available for you. We may at any time terminate
                  the use of autoinvest or
                  change its functionality by giving you notice prior to or after the termination or change.
                </li>
              </ol>
            </li> <!--8.-->
            <li class="big-title">Withdrawal of funds
              <ol>
                <li><strong>Submitting withdrawal requests.</strong> You may withdraw funds held by Income on your behalf in which case you must submit via the investor account instructions indicating
                  the withdrawal amount.
                  The
                  funds shall be transferred to your payment account in accordance with your instructions in a due course. Withdrawal requests cannot be waived, meaning that once you have submitted a
                  withdrawal
                  request, your instructions are final.
                </li>
                <li><strong>Processing withdrawal requests.</strong> We expect to have each withdrawal request processed and payment initiated within 3 business days as of receipt of the request.
                  Nevertheless, we will do
                  our
                  best to process withdrawal requests on a daily basis.
                </li>
                <li><strong>Sufficient funds.</strong> We can only withdraw funds if you have a positive balance of funds exceeding or equal to the requested withdrawal amount. After you have
                  submitted a withdrawal request,
                  the
                  funds which you wish to withdraw shall be reserved on or deducted from your investor account and cannot be used for purchasing Claims.
                </li>
                <li><strong>Eligible payment account.</strong> The funds will only be transferred to a payment account opened in your name with a payment services provider duly licensed to provide
                  services in the respective
                  member state of the European Economic Area or Switzerland and the details of which you have provided via the Marketplace. Withdrawals to a payment account of any third party are
                  expressly
                  prohibited. We may refuse to make payments to a payment account which you have not used for making payments to us or which do not comply with this clause.
                </li>
                <li><strong>Correct payment details.</strong> You are solely responsible for ensuring that any withdrawal instructions, including your payment account number, are complete and correct
                  and you accept and
                  agree
                  that under no circumstances will Income be under any obligation to reverse or amend any withdrawal.
                </li>
                <li><strong>Third party service provider.</strong> The terms of withdrawal of funds (except clause 9.3.) will not apply if the funds are held by a third-party payment service provider.
                  In the latter case,
                  the
                  terms and conditions of such third-party payment service provider shall apply.
                </li>
              </ol>
            </li> <!--9.-->
            <li class="big-title">INCOME’S OBLIGATIONS AND LIABILITY
              <ol>
                <li>In addition to other functions specifically set forth in this User Agreement, Income as the operator of the Marketplace shall undertake to perform the following activities:
                  <ol>
                    <li>transfer the price of the Claim from your investor account to relevant payment account of the loan originator;</li>
                    <li>organise distribution the funds received from the loan originators among the creditors who have purchased claims from the loan originators and reflect the funds equivalent to
                      the
                      repayments in relation with your Claims on your investor account;
                    </li>
                    <li>provide you with information about the performance of the Claims as received from loan originators under the same conditions as information is provided to other creditors.
                    </li>
                  </ol>
                </li>
                <li>
                  Income may delegate any of its obligations to third party service providers if this is required under applicable law or if it is necessary for improving the quality of the services
                  provided
                  via the Marketplace.
                </li>
                <li>Income shall not be liable for due performance of loan originator’s obligations and payment obligations of the borrowers deriving from the Claims. You accept that by entering into
                  an
                  assignment agreement on the Marketplace you bear a credit risk in relation to the borrower who is liable for performing the Claim you have acquired and the loan originator who has
                  issued
                  the loan
                  from which the Claim arises.
                </li>
                <li>For the avoidance of doubt, when providing its services to you, Income does not operate in the independent interest of each and every creditor but in the joint interests of all
                  creditors.
                  This means that if parts of a Claim are assigned to different investors, Income acts in the overall interest of all such creditors (at Income’s discretion) and treats the creditors
                  equally.
                </li>
              </ol>
            </li> <!--10.-->
            <li class="big-title">TAXES
              <ol>
                <li><strong>IPaying taxes.</strong> It is your sole responsibility to determine whether, and to what extent, any taxes apply to any transactions you carry out through your investor
                  account, and for
                  withholding,
                  collecting, declaring and paying the correct amounts of tax to the appropriate tax authorities.
                </li>
                <li><strong>Information about taxation obligation.</strong> We will ask loan originators to provide us information about the taxation of your earnings in the country of operations of
                  the loan originator. For
                  the
                  avoidance of doubt, we shall not have any obligation to verify such information. This does not limit your obligation under clause 11.1..
                </li>
                <li><strong>Limitation of our liability.</strong> We are not responsible for your failure to declare and pay taxes and state duties. We are not liable for any misinformation provided
                  by loan originators to
                  you
                  and other users via the Marketplace.
                </li>
              </ol>
            </li> <!--11.-->
            <li class="big-title">SECONDARY MARKET
              <ol>
                <li><strong>The secondary market.</strong> Income may make available a marketplace for reassignment of Claims previously purchased via the Marketplace (“<strong>secondary
                  market</strong>”). As soon as the secondary market is
                  available on our Marketplace, you will be able to sell the Claims you have previously acquired from loan originators or to purchase Claims from other users of the Marketplace which
                  they
                  have
                  previously acquired via the Marketplace.
                </li>
                <li><strong>Procedure for assignment.</strong> The procedure for reassignment of Claims on the secondary market shall conform to the one described in clause 7., with the following
                  differences:
                  <ol>
                    <li>each purchasing decision shall be deemed as an offer to enter into a transaction and the user of the Marketplace selling a Claim (i.e. the assignor) shall be the one to approve
                      and
                      finalise the transaction;
                    </li>
                    <li>if a Claim is listed on the secondary market and you place your purchase offer to acquire such Claim, there is no guarantee that the Claim will be sold to you as there may be
                      other
                      users
                      who have also offered to acquire the Claim.
                    </li>
                  </ol>
                </li>
                <li><strong>Listing Claims on secondary market.</strong> To list a Claim on a secondary market, the assignor shall determine the price of the Claim on the secondary market and other
                  terms and conditions
                  required
                  by Income. The Claim can be assigned via the secondary market as a whole and cannot be split into several claims by the assignor.
                </li>
                <li><strong>Offer.</strong> The listing of a Claim by you on the secondary market shall be deemed as an offer to all other users of the Marketplace to enter into an assignment
                  agreement with you in respect
                  to
                  transferring the Claim.
                </li>
                <li><strong>Acceptance.</strong> If another user of the Marketplace wishes to purchase a Claim from you (or if you wish to purchase a Claim from another user), the user with purchasing
                  interest (i.e. the
                  assignee) must indicate their wish to purchase the Claim by accepting the offer referred to in clause 12.5.12.4. either entirely (i.e. to acquire the whole Claim being offered) or
                  partially (i.e.
                  by acquiring a portion of the Claim being offered) at the offered price. Upon acceptance of the assignor’s offer, the price of the Claim shall be reserved from the assignee’s funds.
                </li>
                <li><strong>Completion of transaction.</strong> Once the assignee has accepted the offer by the assignor, the title of the Claim is deemed to have been assigned from the assignor to
                  the assignee, the funds
                  reserved on the investor account of the assignee shall be transferred to the assignor and the assigned Claim shall be reflected on the investor account of the assignee.
                </li>
              </ol>
            </li> <!--12.-->
            <li class="big-title">AMENDMENT OF THIS USER AGREEMENT
              <ol>
                <li><strong>Right to make amendments.</strong> We reserve the right to unilaterally amend the terms and conditions of this User Agreement from time to time. We will notify you before
                  any changes to this User
                  Agreement enter into force. The changes will become effective and shall be deemed accepted by you, if you keep on using the Marketplace after we have notified you of the changes and
                  the
                  date for
                  the changes to take effect has passed.
                </li>
                <li><strong>Notifying you of amendments.</strong> We will notify you of any amendments to this User Agreement that we consider likely to affect your rights and obligations.
                </li>
                <li><strong>Consequences of rejecting the amendments.</strong> If you do not accept the amendments to this User Agreement via your investor account before the amendments enter into
                  force, you will not be
                  allowed
                  to enter into any transaction on the Marketplace (including to transfer or acquire any Claims) nor add any funds to your investor account, however, you will be allowed to withdraw
                  existing
                  funds
                  from your investor account. As soon as you have withdrawn all funds from your investor account and you do not hold any outstanding Claims, this User Agreement will be automatically
                  terminated. The
                  same consequences apply as for a regular termination of this User Agreement.
                </li>
              </ol>
            </li> <!--13.-->
            <li class="big-title">TERMINATION
              <ol>
                <li><strong>Preconditions.</strong> You may close your investor account at any time and thereby terminate this User Agreement, provided that there are no monetary claims against you in
                  connection with the
                  use of
                  the Marketplace and there are no outstanding Claims which have been assigned to you. If there are any outstanding Claims, you may only terminate the User Agreement and close your
                  investor
                  account,
                  once all repayments have been duly made or the Claims have been reassigned on the secondary market (if any). We shall be under no obligation to remunerate you for the outstanding
                  amounts
                  of the
                  Claims.
                </li>
                <li><strong>Termination by you.</strong> You can close your investor account and thereby terminate this User Agreement through your investor account.</li>
                <li><strong>Consequences.</strong> Once your investor account is closed you will have no further access to it. We will no longer be under no obligation to fulfil any of our obligations
                  deriving from this
                  Agreement. All funds held on your investor account shall be transferred back to your payment account.
                </li>
                <li><strong>Termination by us.</strong>
                  <ol>
                    <li>We have the right to restrict, suspend or close your investor account and/or terminate this User Agreement if you breach any of your obligations under this User Agreement. Your
                      access to
                      your investor account may also be suspended at any time at the request of any competent authority should there be any reason for investigating a fraud or any other illegal
                      activity in
                      which case
                      you will not, among other, be able to withdraw your funds or complete any other actions forbidden by the authorities.
                    </li>
                    <li>We have the right to close unconfirmed investor accounts or investor accounts that have been inactive (i.e. no Claims allocated to the investor account) for a period of twelve
                      months
                      or
                      more and/or if we decide not to continue provision of services via the Marketplace in which case you will be notified about the status of your investor account using the contact
                      details you have
                      provided us.
                    </li>
                    <li>We will make all reasonable efforts to give you prior notice (at least 14 days) of the termination of this User Agreement and closure of your investor account, unless we are
                      prohibited
                      from doing so or in case the circumstances warrant termination without prior notice.
                    </li>
                  </ol>
                </li>
              </ol>
            </li> <!--14.-->
            <li class="big-title">CLOSURE OF THE MARKETPLACE
              <div class="like-li">In case the Marketplace operations are terminated, and the Marketplace closed, Income may either by itself or with the help of a third party facilitate the
                collection of the Claims which
                are
                outstanding after the closure of the Marketplace. Income may transfer any and all of its rights or obligations (together or separately) under this User Agreement and any agreements
                concluded on
                the Marketplace to any third party at Income’s discretion (this includes the transfer of any data, including personal data, to such third party). You hereby give your irrevocable
                consent
                for such
                transfer.
              </div>
            </li> <!--15.-->
            <li class="big-title">FINAL PROVISIONS
              <ol>
                <li>If we are unable to perform the services via the Marketplace due to circumstances beyond our control, including but not limited to an event of force majeure, change of law or
                  change in
                  sanctions policy, we will not bear any liability to you or any third party.
                </li>
                <li>Any notice or other communication from Income to you will be done via e-mail to the e-mail address associated with your investor account or via your investor account. You are
                  considered
                  to
                  have received the notice or other communication on the next day as of sending it or making it available via your investor account.
                </li>
                <li>Any notice or other communication from you to Income will be done via e-mail to hello@getincome.com. We are considered to have received the notice or other communication on the
                  next
                  business
                  day as of sending the notice.
                </li>
                <li>Notwithstanding any other provision of this User Agreement, any translation is provided solely for your convenience. In case of discrepancy between the texts in English and the
                  texts in
                  other languages, the text in English shall be deemed as correct.
                </li>
                <li>These terms and conditions are governed and construed in accordance with Estonian law. If any claims and disputes arise between you and the Income, they are to be settled by
                  informal
                  negotiation between you and the Income. If we are not able to come to an agreement, further claims arising out of or in connection with this User Agreement will be resolved in Harju
                  county
                  court
                  in Estonia.
                </li>
              </ol>
            </li> <!--16.-->
          </ol>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader'
import marketingHelper from '@/helpers/marketingHelper'

export default {
  name: 'UserAgreement',
  components: {Loader},
  data()
  {
    return {
      customHtml: '',
      reservedInfo: false
    }
  },
  mounted()
  {
    marketingHelper.getMarketingRequest('agreement').then((response) =>
    {
      this.customHtml = marketingHelper.parseContent(response)
    }).catch(error =>
    {
      console.log(error)
      this.reservedInfo = true
      this.customHtml = ' '
    })
  }
}
</script>
<style lang="scss" scoped>

.header-text {
  font-weight: bold;
  margin: 52px auto 16px 5%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.top-block {
  background-repeat: no-repeat;
  background-size: cover;
}

.user-agreement {
  text-align: justify;

  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }

  .top-title {
    text-transform: uppercase;
    font-weight: bold;
  }

  ol {
    list-style: none;
    counter-reset: li;
    padding: 0;
    margin-left: 1px;

    li {
      padding-top: 5px;
    }
  }

  .like-li {
    margin-left: 1px;
  }

  .big-title:first-line {
    text-transform: uppercase;
    font-weight: bold;
  }

  li:before {
    counter-increment: li;
    content: counters(li, ".") ". ";
    font-weight: bold;
  }
}

@media only screen and (max-width: 500px) {
  ol {
    margin-left: 1px !important;
  }
  .like-li {
    margin-left: 1px !important;
  }

  .header-text {
    h1 {
      font-size: 29px;
      line-height: 29px;
    }
  }
  .ua{
    font-size: 14px;
  }
}
</style>
